/* tslint:disable */
import { CityModel, HousingTypeModel } from './abre-cuentas.model';


/**
 * Inicialización de la clase AddressModel, modelo de la dirección de contácto del usuario
 * *Set AddressModel class, model of user's contact address*
 * 
 * @access public
 * @type {class}
 */
export class AddressModel {
  /**
   * Ciudad de dirección de contácto del usuario
   * 
   * *User's city contact address*
   * 
   * @type {string} address
   */
  city: CityModel;

  /**
   * Dirección de contácto del usuario
   * 
   * *User's contact address*
   * 
   * @type {string} address
   */
  address: string;

  /**
   * Entrada de la dirección de contácto del usuario
   * 
   * *User's contact address Input*
   * 
   * @type {string} addressInput
   */
  addressInput: string;

  /**
   * Detalle de la dirección de contácto del usuario
   * 
   * *User's contact address details*
   * 
   * @type {string} detail
   */
  detail: string;

  /**
   * Entrada de la dirección de contácto del usuario
   * 
   * *User's contact address Input*
   * 
   * @type {string} addressInput
   */
  stratum?: string;

  /**
   * Detalle de la dirección de contácto del usuario
   * 
   * *User's contact address details*
   * 
   * @type {string} detail
   */
  housingType?: HousingTypeModel;

}

/**
 * Inicialización de la clase ContactModel, modelo de Información de contácto del usuario
 * *Set ContactModel class, model of user's contact info*
 * 
 * @access public
 * @type {class}
 */
export class ContactModel {
  /**
   * Número de teléfono de contácto del usuario
   * 
   * *User's contact mobile number*
   * 
   * @type {string} mobile_number
   */
  mobile_number: string;

  /**
   * Número de teléfono de trabajo de contácto del usuario
   * 
   * *User's contact mobile employment number*
   * 
   * @type {string} employment_number
   */
  employment_number: string;

  /**
   * Correo electrónico de contácto del usuario
   * 
   * *User's contact email*
   * 
   * @type {string} email
   */
  email: string;

  /**
   * Detalle de la dirección de contácto del usuario
   * 
   * *User's contact address details*
   * 
   * @type {string} address
   */
  address: AddressModel;
}
